module.exports = __webpack_public_path__ + "static/img/download-ios.e21c1284.png";